import { IWizardStep } from "..";
import { WizardContext, WizardContextProvider } from "./WizardContext";

export interface IWizardContext {
    UpdateSetStep: React.Dispatch<React.SetStateAction<(tabIndex: number) => void>>;
    SetStep?: (tabIndex: number) => void;

    UpdateSteps: React.Dispatch<React.SetStateAction<IWizardStep[]>>;
    Steps?: IWizardStep[];

    UpdateSubmitWizard?: React.Dispatch<React.SetStateAction<(() => Promise<void>)>>;
    SubmitWizard?: (() => Promise<void>);

    ShouldSaveOnSubmit?: boolean;
    UpdateShouldSaveOnSubmit?: React.Dispatch<React.SetStateAction<boolean>>;

    IsCompleting?: boolean;
    UpdateIsCompleting: React.Dispatch<React.SetStateAction<boolean>>;
}

export { WizardContext, WizardContextProvider };
